/**
 * Supported language codes for the OM platform.
 */
export const SUPPORTED_LANGUAGES = ['en', 'hi', 'te', 'ta', 'gu', 'pa'] as const;

export type LanguageCode = typeof SUPPORTED_LANGUAGES[number];

export const DEFAULT_LANGUAGE: LanguageCode = 'en';

export interface LanguageOption {
  code: LanguageCode;
  /** Label in English */
  label: string;
  /** Label in native script */
  nativeLabel: string;
  /** BCP 47 locale tag for browser APIs */
  locale: string;
  /** Google Fonts Noto Sans family name for this script (null for Latin) */
  notoFontFamily: string | null;
}

export const LANGUAGE_OPTIONS: LanguageOption[] = [
  {
    code: 'en',
    label: 'English',
    nativeLabel: 'English',
    locale: 'en-US',
    notoFontFamily: null,
  },
  {
    code: 'hi',
    label: 'Hindi',
    nativeLabel: 'हिन्दी',
    locale: 'hi-IN',
    notoFontFamily: 'Noto Sans Devanagari',
  },
  {
    code: 'te',
    label: 'Telugu',
    nativeLabel: 'తెలుగు',
    locale: 'te-IN',
    notoFontFamily: 'Noto Sans Telugu',
  },
  {
    code: 'ta',
    label: 'Tamil',
    nativeLabel: 'தமிழ்',
    locale: 'ta-IN',
    notoFontFamily: 'Noto Sans Tamil',
  },
  {
    code: 'gu',
    label: 'Gujarati',
    nativeLabel: 'ગુજરાતી',
    locale: 'gu-IN',
    notoFontFamily: 'Noto Sans Gujarati',
  },
  {
    code: 'pa',
    label: 'Punjabi',
    nativeLabel: 'ਪੰਜਾਬੀ',
    locale: 'pa-IN',
    notoFontFamily: 'Noto Sans Gurmukhi',
  },
];

export function isValidLanguageCode(value: unknown): value is LanguageCode {
  return typeof value === 'string' && (SUPPORTED_LANGUAGES as readonly string[]).includes(value);
}

export function getLanguageOption(code: LanguageCode): LanguageOption {
  return LANGUAGE_OPTIONS.find((l) => l.code === code) ?? LANGUAGE_OPTIONS[0];
}
